import { IStatusMessage } from '../../shared';
export interface LeaveRequest {
    AuthRequestID: number;
    EmployeeListID: string;
    UserListID: string;
    RoleGroupID: string;
    TaskListID: string;
    EmpAuthStartDate: Date;
    EmpAuthEndDate: Date;
    MaxHours: number;
    RequestHours: number;
    AuthDesc: string;
    RequestStatusID: LeaveRequestStatus;
    ModifiedDateTime: Date;
    RequestStatus: string;
    LeaveAccrualInfo: string;
    Status: IStatusMessage;
    Row_Version: string;
    dates: Date[];
    selected: boolean;
    IsReadOnly: boolean;
    PIListID?: string;
    SIListID?: string;
}


export enum LeaveRequestStatus {
  Saved = 0.0,
  Signed = 1.0,
  Validated = 1.5,
  Approved = 2.0,
  Disapproved = 3.0
}
